<template>
  <header class='layout-header'>
    <div class="layout-header-inner">
      <nav class="header-nav">
        <!-- logo -->
        <div class="login_left">
          <img src="../../assets/images/client/logo.png" alt="" class="logo">
          <!-- 导航菜单 -->
          <div class="menu_tabs">
            <tabs></tabs>
          </div>
        </div>
        <!-- 登陆按钮部分 -->
        <div class="login_right">
          <div class="info" v-if="profile && profile.userName">
            <el-dropdown>
              <span class="el-dropdown-link">
                <span class="name">欢迎 {{ profile.userName || 'xxx'}}</span>
                <img class="drop" src="../../assets/images/client/drop.png" alt="">
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item>
                  <div class="box" @click.stop="logout">
                    <i class="logoOut"></i>登出
                  </div>
                </el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div class="btns" v-else>
            <el-button class="px-10 btn-blue" size="mini" @click="login">登录</el-button>
          </div>
        </div>
      </nav>
    </div>
  </header>
</template>
<script>
  import { mapActions, mapMutations ,mapState } from 'vuex';
  import Cookies from 'js-cookie';
  import Tabs from './Tabs.vue'
  import _ from 'lodash';

  export default {
    props:['reload'],
    data() {
      return {
        logo_out: require("../../assets/images/client/logo_out.png")
      };
    },
    computed: {
      ...mapState({
        profile: state=>state.User.profile,
        clientCk: state=>state.User.clientCk,
        loginAddress: state=>state.User.loginAddress,
      }),
    },
    components: {
      Tabs
    },
    mounted() {},
    methods: {
      ...mapMutations(['setProfile']),
      login(){
        location.href = this.loginAddress;
      },
      logout(){
        Cookies.remove(this.clientCk, { path: '/', domain: '.yunxiao.com' });
        this.setProfile({});
        location.reload();
      }
    }
  };
</script>
<style>
</style>
<style lang="sass" rel="stylesheet/scss" scoped>
  .header {
    &-nav {
      display: flex;
      justify-content: space-between;
      .login_left{
        display: flex;
        justify-content: space-between;
        align-items: center;
        .logo {
          height: 34px;
          object-fit: contain;
        }
        .point {
          display: inline-block;
          width: 5px;
          height: 5px;
          border-radius: 50%;
          background: #000;
          margin:0 4px
        }
        strong {
          font-size: 28px;
          color: #333;
          align-items: center;
          display: flex;
        }
      }
      .login_right{
        float:right;
        display: flex;
        position: relative;
        line-height: 68px;
        height: 68px;
        .btns{
          .btn-blue{
            width: 90px;
            height: 30px;
            background-color: #1daef8;
            color: #fff;
            font-size: 14px;
          }
        }
        .info{
          display: flex;
          align-items: center;
          position: relative;
          line-height: normal;
          cursor: pointer;
          .name{
            margin-right: 14px;
          }
          .drop{
            width: 11px;
          }
        }
      }
      .login_right:hover {
        .box{
          display: block;
        }
      }
      .login_left{
        display: flex;
      }
    }
  }
  .layout-header{
    display: flex;
    align-items: center;
    z-index: 10;
    box-shadow: none;
    width: 100%;
    min-width: 1200px;
    background-color: #fff;
    
    &-inner {
      height: 68px;
      line-height: 68px;
      width: 1200px;
    }
  }

  .box{
    width: 100%;
    height: 30px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 14px;
    line-height: 30px;
    color: #333;
    cursor: pointer;
    .logoOut{
      display: inline-block;
      vertical-align: middle;
      margin-right: 10px;
      border-radius: 50%;
      width: 18px;
      height: 18px;
      background: url('../../assets/images/client/logo_out.png') no-repeat;
      background-size: 100%;
    }
  }
  .box:hover{
    background: #f5f5f5;
    color: #1daef8;
  }
</style>



// WEBPACK FOOTER //
// Header.vue?0acd735a